import { StringFormatter } from "../main";
import { NSDialogProps, NSDialog } from "./NSDialog";
import { NSSpace, NSSpaceSizeType } from "./NSSpace";
import { NSTitle } from "./NSTitle";

export interface NSDialogInfoProps extends NSDialogProps
{
	title?: string;
	description?: string | React.ReactNode;
	show_as_code: boolean;
}

export function NSDialogInfo(props: NSDialogInfoProps)
{
	let description = props.description;
	let show_code = false;
	if (typeof description === "string")
		if (props.show_as_code)
		{
			show_code = true;
			description = StringFormatter.toHTML(description);
		}
	return (
		<NSDialog center_dialog {...props} style={{ right: "unset" }}>
			{props.title && (
				<>
					<NSTitle title={props.title} style={{ marginBottom: "0" }} />
					<NSSpace size={NSSpaceSizeType.MINI} />
				</>
			)}
			{
				description && <>
					{
						show_code ?
							<code className="px-2">
								<p style={{ marginBottom: "0" }}>{description}</p>
							</code>
							:
							<div className="px-2">
								<p style={{ marginBottom: "0" }}>{description}</p>
							</div>
					}
				</>
			}
			{
				props.children
			}
		</NSDialog>
	);
}